/**
 * Enum for Order Status
 * @readonly
 * @enum {string}
 */
let OrderStatusEnum = {
    REJECTED:   "REJECTED",
    PENDING:    "PENDING"
};

export default OrderStatusEnum;
